var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worldpay3ds"},[_c('div',{staticClass:"wrap"},[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"550px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }